import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface SRSTMonitoringFilterProps {
  filterType: string;
  setFilterType: (value: string) => void;
}

const SRSTMonitoringFilter: React.FC<SRSTMonitoringFilterProps> = ({ filterType, setFilterType }) => {
  const { t } = useTranslation();
  const SRSTMonitoringFilterType = {
    default: t('VisitReportsPDF.STFilters.showAll'),
    triggerEmpty: t('VisitReportsPDF.STFilters.showEmptyTrigger'),
    triggerNotEmpty: t('VisitReportsPDF.STFilters.showCaptureTrigger'),
  } as const;
  const CustomSelect = styled(Select)({
    '&.MuiInputBase-root': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      borderColor: 'red',
    },
    '& .MuiSelect-select': {
      padding: '10px 12px',
      paddingRight: '24px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #E0E0E0',
    },
  });

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    setFilterType(event.target.value as string);
  };

  const filters = Object.keys(SRSTMonitoringFilterType);
  return (
    <div className="buttons mt-2 mt-lg-0">
      <FormControl sx={{ width: '100%' }}>
        <InputLabel
          id="demo-simple-select-standard-label"
          sx={{ fontFamily: 'Poppins, sans-serif', width: '100%' }}
          shrink
        >
          {t('VisitReportsPDF.STFilters.currentFilterApplied')}
        </InputLabel>
        <CustomSelect
          value={filterType}
          onChange={handleChange}
          id="demo-simple-select-filled"
          label="Current Filter Applied"
          sx={{ width: 250, fontFamily: 'Poppins, sans-serif' }}
        >
          {filters.map(key => (
            <MenuItem key={key} value={key} sx={{ fontFamily: 'Poppins, sans-serif' }}>
              {SRSTMonitoringFilterType[key as keyof typeof SRSTMonitoringFilterType]}
            </MenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    </div>
  );
};

export default SRSTMonitoringFilter;
